// $fromXssmallToMedium: screen and (min-width: 300px) and (max-width: 767px)
ui-cms-footer {
  display: block;

  .ui-container::part(ui-container) {
    @include breakpoint($xsmallMaxWidth) {
      padding: 32px 20px;
    }
  }

  footer {
    position: relative;
    padding: 0 0 60px;
    z-index: 0; // Creating an own z-index-scope prevents children of this element overlapping other elements
    margin-bottom: -37px;
    font-size: 16px;
    line-height: 1.875;

    @include breakpoint($medium) {
      line-height: 1.5;
    }
  }

  .sd-headline {
    margin-bottom: 16px;
  }

  ui-cms-grid {
    margin-bottom: 32px;
  }

  @include breakpoint($small) {
    ui-cms-grid {
      margin-bottom: 48px;
    }
  }

  .sr-only {
    @include sr-only;
  }
}
